import Vue from 'vue';
// eslint-disable-next-line
import {
  GetTasks,
  UpdateTaskStatus,
  AddTaskComment,
} from '@/api/api';
import { Consts } from 'gw-js-lib';

export default {
  namespaced: true,
  state: {
    taskSelected: null,
    tasks: {
      PENDING: [],
      IN_PROGRESS: [],
      COMPLETED: [],
    },
    loading: {
      updateTaskStatus: false,
      addComment: false,
      PENDING: false,
      IN_PROGRESS: false,
      COMPLETED: false,
    },
    filterStatusList: Consts.TaskStatus,
    taskFilterStatus: Consts.TaskStatus.PENDING,
    pagination: {
      page: 1,
      rows: 100,
      order_by: 'orden asc, time_updated desc',
      filters: {
        status: null,
      },
    },
  },

  getters: {
    getTaskLoading(state){
      return state.loading[state.taskFilterStatus];
    },
    /* = Computed properties, perfects to filter data an execute some calculation */
    getTasksFiltered(state) {
      return state.tasks[state.taskFilterStatus];
    },
  },
  actions: {
    /* = Methods */
    async getTasks({ commit, state, }, { tasksStatus, hideLoading }) {
      const tempPagination = {
        ...state.pagination,
      };

      if(state.tasks[state.taskFilterStatus].length == 0 && !hideLoading){
        commit('setLoading', {
          value: true, 
          tasksStatus: tasksStatus
        });
      }

      tempPagination.filters.status = tasksStatus;
      await GetTasks(tempPagination).then((tasks) => {
        commit('setTasks', {
          tasksStatus,
          tasks: tasks.rows,
        });

        commit('setLoading', {
          value: false, 
          tasksStatus: tasksStatus
        });
      }).catch(() => { });
    },

    async updateTask({ commit, state, }, tasksStatus) {
      commit('setLoading', {
        updateTaskStatus: true,
      });
      await UpdateTaskStatus(state.taskSelected.task_id, tasksStatus).then((taskUpdated) => {
        
        if (tasksStatus === Consts.TaskStatus.IN_PROGRESS) {
          //Delete from PENDING and add to IN_PROGRESS
          const currentIndex = state.tasks[Consts.TaskStatus.PENDING].findIndex((t) => t.task_id === taskUpdated.task_id);
          Vue.delete(state.tasks[Consts.TaskStatus.PENDING], currentIndex);
          state.tasks[tasksStatus].push(taskUpdated);

        } else if (tasksStatus === Consts.TaskStatus.COMPLETED) {
           //Delete from IN_PROGRESS and add to COMPLETED List
           const currentIndex = state.tasks[Consts.TaskStatus.IN_PROGRESS].findIndex((t) => t.task_id === taskUpdated.task_id);
          Vue.delete(state.tasks[Consts.TaskStatus.IN_PROGRESS], currentIndex);
          state.tasks[tasksStatus].push(taskUpdated);
        }

        commit('setTasksFilter', tasksStatus);
      }).catch(() => {});
      commit('setLoading', {
        updateTaskStatus: false,
      });
    },
    
    async addComment({
      commit,
      state,
    }, comment) {
      commit('setLoading', {
        addComment: true,
      });
      await AddTaskComment({
        task_id: state.taskSelected.task_id,
        type: 'COMMENT',
        comment,
      }).then((response) => {
        commit('addComment', response);
      }).catch(() => {});
      commit('setLoading', {
        addComment: false,
      });
    },
    async getAllTasks({
      dispatch,
    }, hideLoading) {
      await dispatch('getTasks', { tasksStatus: Consts.TaskStatus.PENDING, hideLoading });
      await dispatch('getTasks', { tasksStatus: Consts.TaskStatus.IN_PROGRESS, hideLoading });
      await dispatch('getTasks', { tasksStatus: Consts.TaskStatus.COMPLETED, hideLoading });
    },
  },
  mutations: {
    /* Mutations are responsible to change the state */
    setTask(state, task) {
      state.taskSelected = task;
    },
    setTasks(state, data) {
      state.tasks[data.tasksStatus] = data.tasks;
    },
    setTasksFilter(state, tasksStatus) {
      state.taskFilterStatus = tasksStatus;
      state.taskSelected = null;
    },
    setUserId(state, userId) {
      state.pagination.filters.assigned_to = userId;
    },
    setCourseId(state, CourseId) {
      state.pagination.filters.course_id = CourseId;
    },
    addComment(state, comment) {
      state.taskSelected.activities.unshift(comment);
    },
    setLoading(state, loading) {
      state.loading[loading.tasksStatus] = loading.value;
    },
    addNewTask(state, newTask) {
      state.tasks[Consts.TaskStatus.PENDING].unshift(newTask);
    },
  },
};
